import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getForgotPasswordTwoFAPath = () => urlHelper(`/forgot-password/2fa`);
